
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welovethisgame",
      function () {
        return require("private-next-pages/welovethisgame.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welovethisgame"])
      });
    }
  